import React from "react";
import { Link } from "react-router-dom";
import IYClogo from "../images/IYClogo.png";

export default function Footer() {
  return (
    <footer
      className="app-footer"
      style={{
        backgroundColor: "#032A66",
        color: "white",
        padding: "2rem 1rem",
        marginTop: "2rem",
      }}
    >
      {/* --- Top section: logo + columns --- */}
      <div
        className="footer-inner"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexWrap: "wrap",
          gap: "2rem",
          maxWidth: 1200,
          margin: "0 auto",
        }}
      >
        {/* --- Logo --- */}
        <div
          className="footer-col footer-brand"
          style={{
            flex: "1 1 220px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <img
            src={IYClogo}
            alt="YCEA logo"
            className="footer-logo"
            style={{ width: "auto", height: "64", marginBottom: "0.5rem"}}
          />
          {/* <p style={{ fontSize: 14, opacity: 0.9, marginTop: 4 }}>
            Youth Congress Election Authority
          </p> */}
        </div>

        {/* --- Quick Links --- */}
        <div className="footer-col footer-links" style={colStyle}>
          <h4 style={headingStyle}>Quick Links</h4>
          <ul style={listStyle}>
            <li><Link to="/" style={linkStyle}>Home</Link></li>
            {/* <li><Link to="/how-to-become-member" style={linkStyle}>How to Become a Member</Link></li> */}
            <li>
              <a
                href="https://www.iyc.in/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                style={linkStyle}
              >
                Privacy Policy
              </a>
            </li>
            <li>
              <a
                href="/FAQ"
                target="_blank"
                rel="noopener noreferrer"
                style={linkStyle}
              >
                FAQ
              </a>
            </li>
          </ul>
        </div>

        {/* --- Downloads --- */}
        <div className="footer-col footer-links" style={colStyle}>
          <h4 style={headingStyle}>Downloads</h4>
          <ul style={listStyle}>
            <li>
              <a
                href="https://play.google.com/store/apps/details?id=com.bif.iyc"
                target="_blank"
                rel="noopener noreferrer"
                style={linkStyle}
              >
                WITHIYC Android App
              </a>
            </li>
            <li>
              <a
                href="https://apps.apple.com/in/app/with-iyc-app/id1621656001"
                target="_blank"
                rel="noopener noreferrer"
                style={linkStyle}
              >
                WITHIYC iOS App
              </a>
            </li>
          </ul>
        </div>

        {/* --- Contact --- */}
        <div className="footer-col footer-links" style={colStyle}>
          <h4 style={headingStyle}>Contact</h4>
          <address style={{ lineHeight: 1.6, fontStyle: "normal" }}>
            Email:{" "}
            <a href="mailto:support@iyc.in" style={linkStyle}>
              support@iyc.in
            </a>
            <br />
            Phone:{" "}
            <a href="tel:+911234567890" style={linkStyle}>
              +91-11-23352472
            </a>
          </address>
        </div>
      </div>

      {/* --- Bottom Bar --- */}
      <div
        className="footer-bottom"
        style={{
          borderTop: "1px solid rgba(255,255,255,0.2)",
          marginTop: "2rem",
          paddingTop: "1rem",
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "1rem",
          maxWidth: 1200,
          margin: "2rem auto 0",
          fontSize: 14,
        }}
      >
        <div>
          © {new Date().getFullYear()} Youth Congress Election Authority — All
          rights reserved.
        </div>
        <div style={{ opacity: 0.9 }}>Built with ❤️</div>
      </div>
    </footer>
  );
}

/* --- Reusable style snippets --- */
const colStyle = {
  flex: "1 1 180px",
  minWidth: 160,
};

const headingStyle = {
  marginBottom: "0.5rem",
  fontSize: 18,
  fontWeight: 600,
  color: "white",
};

const listStyle = {
  listStyle: "none",
  padding: 0,
  margin: 0,
  lineHeight: 1.8,
};

const linkStyle = {
  color: "white",
  textDecoration: "none",
  opacity: 0.9,
};
